const data = [
    { id: 0, text: "2024中国上市公司首席品牌官" },
    { id: 1, text: "2024中国上市公司经典品牌案例" },
    { id: 2, text: "2024中国上市公司优秀品牌案例" },
];

export default data;
